import PropTypes from "prop-types";
import React from "react";

import { PropTypeShapes } from "../../types";
import Icon from "../interface/Icon";
import { withOptionalTooltip } from "../interface/Tooltip";
import onPulseAnimationEnd from "../onPulseAnimationEnd";

const ToolbarDropdownButton = props => {
  const btn = (
    <div
      id={props.id ? props.id : null}
      className={`toolbarDropdownBtn ${props.isSmall ? "small" : ""} ${props.pulse ? "pulse" : ""}`}
      onClick={props.onClick}
      onAnimationEnd={onPulseAnimationEnd}
    >
      {props.label}
      {props.disabled ? null : <Icon icon="downArrow" color={props.isSmall ? "iconMid" : "iconMono"} />}
    </div>
  );

  return withOptionalTooltip(btn, props.tooltip, { placement: "bottom-start" });
};
ToolbarDropdownButton.propTypes = {
  onClick: PropTypes.func,
  label: PropTypeShapes.elementOrArrayOrString.isRequired,
  id: PropTypes.string,
  isSmall: PropTypes.bool,
  tooltip: PropTypes.string,
  pulse: PropTypes.bool,
  disabled: PropTypes.bool
};

export default ToolbarDropdownButton;
